import React, { useEffect, useState } from "react";
import Sidebar from "../../../components/AdminComponents/SideNav";
import { Table, Spin, Switch, Popconfirm, Pagination } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setSubMenuClick } from "../../../store/slices/SubMenuClick";
import {
  // EditOutlined,
  DeleteTwoTone,
  CloseOutlined,
  CheckOutlined,
  SwapOutlined,
} from "@ant-design/icons";
import "./settingStyles.css";
import { SettingsMenu } from "../../../components/AdminComponents/MenuItems";
import EditableImage from "../../../components/icons/EditIcon";
import Axios from "../../../api/Axios";
import { message } from "antd";
import { setTnmisSubmenu } from "../../../store/slices/tnmisSubmenu";
import { setSubMenuTrakL } from "../../../store/slices/SubMenuTrakL";
import { remainingViewportHeight } from "../../../components/icons/ApplicationColor";
import { useSelector } from "react-redux";
import { getUpdateStatus2 } from "../../../components/AdminComponents/ViewUpdateIndexTnAdmin";
import CommonTopDetails from "../../../components/AdminComponents/CommonTopDetails";
// import { GetFormattedDate } from "../../../components/utils/DateTimeUtils";
const SettingsUsers = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const [filterData, setFilterData] = useState({
    pageSize: 15,
    currentPage: 1,
    url: `/userlist/?sort_by=-created_at&is_superadmin=True`,
    active: true,
    search: "",
  });
  const { pageSize, currentPage, url, active, search } = filterData;
  const userInfo = useSelector((state) => state.user);
  const updateAuth = getUpdateStatus2(userInfo, 0, 0);
  const renderStatus = (text, record) => {
    if (record.status) {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            style={{
              width: "1.8rem",
              height: "1.8rem",
              borderRadius: "50%",
              backgroundColor: "#52c41a",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CheckOutlined
              style={{ color: "#fff", fontSize: "1.2rem", fontWeight: "700" }}
            />
          </div>
        </div>
      );
    } else {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            style={{
              width: "1.8rem",
              height: "1.8rem",
              borderRadius: "50%",
              backgroundColor: "#ff4d4f",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CloseOutlined
              style={{ color: "#fff", fontSize: "1rem", fontWeight: "600" }}
            />
          </div>
        </div>
      );
    }
    // else {
    //   return text;
    // }
  };
  const columns = [
    {
      title: "User ID",
      dataIndex: "user_id",
      key: "user_id",
    },
    {
      title: "First Name",
      dataIndex: "first_name",
      key: "first_name",
    },
    {
      title: "Last Name",
      dataIndex: "last_name",
      key: "last_name",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: 300,
    },

    {
      title: "Creation Date",
      dataIndex: "created_at",
      key: "created_at",
      render: (text, record) => {
        const date = new Date(text);
        const month = date
          .toLocaleString("default", { month: "short" })
          .toUpperCase();
        const day = date.getDate();
        const year = date.getFullYear();
        const formattedDate = `${day} ${month} ${year}`;
        return formattedDate;
      },
    },
    {
      title: "Last Update",
      dataIndex: "updated_at",
      key: "updated_at",
      render: (text, record) => {
        const date = new Date(text);
        const month = date
          .toLocaleString("default", { month: "short" })
          .toUpperCase();
        const day = date.getDate();
        const year = date.getFullYear();
        const formattedDate = `${day} ${month} ${year}`;
        return formattedDate;
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      align: "center",
      render: renderStatus,
    },
    ...(updateAuth
      ? [
          {
            title: "Actions",
            key: "action",
            align: "center",
            render: (text, record) => {
              return (
                <div
                  style={{ display: "flex", justifyContent: "center" }}
                  key={record.id}
                >
                  {/* <DeleteTwoTone onClick={handleClick(record)} /> */}
                  <EditableImage
                    handleRowClick={handleRowClick}
                    recordId={record.id}
                  />
                  <Popconfirm
                    title={active ? "Archive Admin" : "Unarchive Admin"}
                    description=" "
                    onConfirm={() =>
                      active ? handleDelete(record) : handleDelete2(record)
                    }
                    // onCancel={cancel}
                    okText="Yes"
                    cancelText="No"
                    placement="leftTop"
                  >
                    {active ? (
                      <DeleteTwoTone
                        style={{
                          cursor: "pointer",
                          fontSize: "1.8rem",
                          marginLeft: "0.9rem",
                        }}
                        // onClick={() => {
                        //   handleDelete(record);
                        // }}
                        title="delete"
                        twoToneColor="#eb2f96"
                      />
                    ) : (
                      <SwapOutlined
                        style={{
                          cursor: "pointer",
                          fontSize: "1.8rem",
                          marginLeft: "0.9rem",
                        }}
                        // onClick={() => {
                        //   handleDelete(record);
                        // }}
                        title="unarchive"
                      />
                    )}
                  </Popconfirm>
                </div>
              );
            },
          },
        ]
      : []),
  ];
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  const handleDelete = async (record) => {
    const updatedValues = {
      status: false,
    };
    try {
      await Axios.put(`/user/${record.id}/`, updatedValues, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      LoadData();
      CreateSuccessfull("archived");
    } catch (err) {
      //console.log(err);
      CreateFailed("archived");
    }
  };
  const handleDelete2 = async (record) => {
    const updatedValues = {
      status: true,
    };
    try {
      await Axios.put(`/user/${record.id}/`, updatedValues, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      LoadData();
      CreateSuccessfull("Unarchived");
    } catch (err) {
      //console.log(err);
      CreateFailed("Unarchived");
    }
  };
  const CreateSuccessfull = (props) => {
    messageApi.open({
      type: "success",
      content: `Admin has been ${props}.`,
      duration: 5,
    });
  };

  const CreateFailed = (props) => {
    messageApi.open({
      type: "error",
      content: `Admin have not been ${props}.`,
      duration: 5,
    });
  };
  const handleRowClick = (record) => {
    history(`/access-manager/admins/edit-user/${record}`);
  };
  const [data, setData] = useState([]);

  const [loading, setLoading] = useState(true);
  const [itemsLength, setItemsLength] = useState();
  // const [active, setActive] = useState(true); // State to track the switch status
  //console.log(active);

  const LoadData = async () => {
    let doNothing = false;
    let passUrl = url;
    if (search?.length > 0) {
      if (search.length > 2) {
        passUrl += `&page=${currentPage}&page_size=${pageSize}&status=${
          active ? "True" : "False"
        }&search=${search}`;
      } else {
        doNothing = true;
      }
    } else {
      passUrl += `&page=${currentPage}&page_size=${pageSize}&status=${
        active ? "True" : "False"
      }`;
    }
    if (!doNothing) {
      setLoading(true);
      try {
        const res = await Axios.get(passUrl);
        setData(res.data.results);
        setItemsLength(res.data.count);
        setLoading(false);
      } catch (err) {
        //console.log(err);
      }
    }
  };

  const handleSearchChange = (event) => {
    setFilterData((prevData) => ({
      ...prevData,
      search: event.target.value,
      currentPage: 1,
    }));
  };

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setSubMenuClick(false));
    dispatch(setTnmisSubmenu(false));
    dispatch(setSubMenuTrakL(false));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active, dispatch]);

  const handleSwitchChange = () => {
    setFilterData((prevData) => ({
      ...prevData,
      active: !prevData.active,
      search: "",
    }));
  };

  const history = useNavigate();

  const onShowSizeChange = (current, size) => {
    setFilterData((prevData) => ({
      ...prevData,
      pageSize: size,
    }));
  };

  const onPageChange = (page, pageSize) => {
    setFilterData((prevData) => ({
      ...prevData,
      currentPage: page,
    }));
  };
  useEffect(() => {
    LoadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterData]);

  return (
    <Sidebar props={SettingsMenu}>
      {contextHolder}
      <div>
        <CommonTopDetails
          title="Trainery Admins"
          titleSuffix={`${itemsLength || 0} admin(s)`}
          searchPlaceholder="Search by..."
          searchAction={handleSearchChange}
          showAddButton={updateAuth}
          addButtonProps={{
            modalType: "Redirect",
            redirctlink: `/access-manager/admins/add-user`,
          }}
          customContent={
            <Switch
              style={{
                backgroundColor: active ? "#50C878" : "#FF0000",
                minWidth: "90px",
              }}
              checked={active}
              disabled={loading}
              checkedChildren="ACTIVE"
              unCheckedChildren="INACTIVE"
              onChange={handleSwitchChange}
            />
          }
        />

        <div className="form-container-3">
          <Spin spinning={loading}>
            <Table
              size="small"
              rowKey="id"
              dataSource={data}
              columns={columns}
              bordered
              className="table-container"
              pagination={false}
              style={{ margin: "1rem" }}
              scroll={{
                x: 1000,
                y: `${remainingViewportHeight(24)}px`,
              }}
            />
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                padding: "1rem",
              }}
            >
              <Pagination
                size="small"
                showSizeChanger
                onShowSizeChange={onShowSizeChange}
                onChange={onPageChange}
                pageSizeOptions={["10", "15", "30", "50", "100"]}
                showQuickJumper
                current={currentPage}
                defaultPageSize={pageSize}
                total={itemsLength}
              />
            </div>
          </Spin>
        </div>
      </div>
    </Sidebar>
  );
};

export default SettingsUsers;
